<template>
	<div class="">
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Invoice" />
			</div>
			<!-- <div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<button
						type="button"
						class="btn btn-primary btn-with-shadow"
						@click="openAddEditModal"
					>
						Invoice Request
					</button>
				</div>
			</div> -->
		</div>
		<hr
			style="
				border-top: 2px solid black;
				font-weight: bold;
				margin-bottom: 20px !important;
			"
		/>
		<app-table :id="tableId" :options="options" @action="getListAction" />
        <invoice-history-table-form
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:form-id="formId"
			:value="value"
			:row-data="rowData"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/>
		
		<app-delete-modal 
			v-if="deleteConfirmationModalActive" 
			:preloader="deleteLoader" 
			modal-id="demo-delete" 
			@confirmed="confirmed" 
			@cancelled="cancelled" 
		/>


        <invoice-history-approve-form
			v-if="confirmModalApprove"
			:table-id="tableId"
			:form-id="formIdApprove"
			:confirmInvoiceId="Number(confirmInvoiceId)"
			:value="value"
			:row-data="rowData"
			:selected-url="selectedUrl"
			@close-modal="cancelConfirm"
		/>
        <invoice-history-reject-form
			v-if="confirmModalReject"
			:table-id="tableId"
			:form-id="formIdReject"
			:confirmInvoiceId="Number(confirmInvoiceId)"
			:value="value"
			:row-data="rowData"
			:selected-url="selectedUrl"
			@close-modal="cancelConfirmReject"
		/>
		<modal-view-p-d-f
			v-if="showPDF"
			:selected-url="pdfUrl"
			@close-modal="closeModalViewPdf"
		/>

	</div>
</template>

<script>
import CoreLibrary from "../../../../../../../../core/helpers/CoreLibrary.js";
import { InvoiceHistoryTableSchema } from "./InvoiceHistoryTableSchema";
import { urlGenerator } from "../../../../../../../Helpers/AxiosHelper";
import { INVOICE_HISTORY_V2 } from "../../../../../../../Config/ApiUrl";
import ModalViewPDF from "./ModalViewPDF.vue";

export default {
	components: {
		ModalViewPDF,
	},
	extends: CoreLibrary,
	name: "InvoiceHistoryTable",
	inject: ["eventHub"],
	mixins: [InvoiceHistoryTableSchema],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
    data() {
		return {
			pdfUrl:'',
			showPDF: false,
			preloader: false,
			inputs: {},
			modalId: this.formId,
			modalTitle: this.$t("add"),
					
			confirmAction: null,
			confirmInvoiceId: null,
			confirmModalApprove: false,
			confirmModalReject: false,
			confirmModalActive: false,
			confirmLoader: false,
		};
	},
	async created() {
		await this.fetchPermission(); 
		this.options.columns = [...this.tableColumns];
	},
	mounted() {
		window.handleBtnEdit = (id) => {
			this.handleEdit(id);
		};
		window.handleBtnView = (id) => {
			this.handleView(id);
		};
		window.handleBtnDownloadPDF = (id) => {
			this.handleDownloadPDF(id);
		};
		window.__approveInvoice = (id) => {
			this.handleApprove(id);
		};
		window.__rejectInvoice = (id) => {
			this.handleReject(id);
		};
		window.handleBtnSendMail = (id) => {
			this.handleSendMail(id);
		};
		
	},
	methods: {
		/**
		 * for open add edit modal
		 */
		
		async fetchPermission() {
			try {
				const res = await axios.get('/getPermission');
				this.userPermissions = res.data.permissions || [];
			} catch (err) {
				console.error(err);
			}
		},

		can(permission) {
			return Array.isArray(this.userPermissions) && this.userPermissions.includes(permission);
		},
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},
        
		closeAddEditModal() {
			$("#invoice-history-table-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;

			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				// this.selectedUrl = INVOICE_HISTORY_V2 + "/" + rowData.id;
				// this.openAddEditModal();
				
				window.location.href = `/transaction/profile-lead/invoice/invoice-request-v2/`+rowData.id;
				
			} else if (actionObj.title == this.$t("Duplicate Invoice")) {
				axios
					.post(`/transaction/invoice/${rowData.id}/duplicate`)
					.then((res) => {
						this.$hub.$emit("reload-" + this.tableId);
						this.$toastr.s(res.data.message);
					})
					.catch((err) => {
						this.$hub.$emit("reload-" + this.tableId);
						this.$toastr.e(err.response.data.message);
					});
			}else if (actionObj.title == 'Print') {
				window.location.href = `/transaction/profile-student/invoice-v2/invoice-process/pdf/`+rowData.id;
			} else if (
				actionObj.title != "Delete" ||
				actionObj.title != this.$t("edit")
			) {
				this.selectedUrl = INVOICE_HISTORY_V2 + "/" + rowData.id;
				this.openAddEditModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			// let url = `${this.Endpoint}/${this.rowData.id}`;
			let url = INVOICE_HISTORY_V2 + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
		reloadTable() {
			this.$hub.$emit("reload-" + this.tableId);
		},
		handleApprove(id) {
			this.selectedUrl = INVOICE_HISTORY_V2 + "/" + id;
			this.confirmAction = "approve";
			this.confirmInvoiceId = id;
			this.confirmModalApprove = true;
		},
		handleReject(id) {
			this.selectedUrl = INVOICE_HISTORY_V2 + "/" + id;
			this.confirmAction = "reject";
			this.confirmInvoiceId = id;
			this.confirmModalReject = true;
		},

		cancelConfirm() {
			this.confirmModalApprove = false;
			this.confirmAction = null;
			this.confirmInvoiceId = null;
  			this.removeBackdrop(); 
		},
		cancelConfirmReject() {
			this.confirmModalReject = false;
			this.confirmAction = null;
			this.confirmInvoiceId = null;
  			this.removeBackdrop(); 
		},
		removeBackdrop() {
			document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
			document.body.classList.remove('modal-open'); // kalau body masih ke-lock scroll
			document.body.style = ""; // reset style
		},
		handleEdit(id){
			location.href=`/transaction/profile-lead/invoice/invoice-request-v2/${id}`;
		},
		handleView(id){
			this.pdfUrl = `/transaction/invoice-v2/viewPDF/${id}`;
			this.showPDF = true;
		},
		handleSendMail(id){
			
			Swal.fire({
				title: "",
				text: "Are you sure you want to send an invoice to the student's parents?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {

				if (result.isConfirmed) {
					axios
						.get(`/transaction/invoice-v2/sendMail/${id}`)
						.then((res) => {
							this.$toastr.s(res.data.message);
						})
						.catch((err) => {
							console.log(err);
						});
				}
			
			});
		},
		closeModalViewPdf() {
			this.showPDF = false;
		},
		handleDownloadPDF(id){
			window.location.href = `/transaction/profile-student/invoice-v2/invoice-process/pdf/`+id;
		},

	},
};
</script>
